import { makeStyles } from '@material-ui/core/styles';
import DelaWeekViewSvg from '../Images/DelaViews/WeekView.svg';
import DelaMonthViewSvg from '../Images/DelaViews/MonthView.svg';
import DelaQuarterViewSvg from '../Images/DelaViews/QuarterView.svg';
import DelaYearViewSvg from '../Images/DelaViews/YearView.svg';
import DelaDayViewSvg from '../Images/DelaViews/DayView.svg';
import WeekViewSvg from '../Images/WeekView.svg';
import MonthViewSvg from '../Images/MonthView.svg';
import QuarterViewSvg from '../Images/QuarterView.svg';
import YearViewSvg from '../Images/YearView.svg';
import DayViewSvg from '../Images/DayView.svg';
import BlankWeekViewSvg from '../Images/blankWeekView.svg';
import BlankDayViewSvg from '../Images/blankDayView.svg';

export const STYLED_CHART_RANGE_ITEM_VARIANT = {
  WHITE: 'WHITE',
  PURPLE: 'PURPLE',
  BLANK: 'BLANK'
};

const baseStyles = theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  },
  itemContainer: {
    borderRight: `1px solid ${theme.palette.grey[400]}`
  },
  totalContainer: { borderLeft: `1px solid ${theme.palette.grey[400]}` },
  openButton: {},
  timeContainer: {},
  timeContainerFixedRange: {},
  timeContainerDay1: {},
  timeContainerDay2: {},
  timeContainerDay3: {},
  timeContainerDay4: {},
  timeContainerDay5: {},
  timeContainerDay6: {},
  timeContainerDay7: {}
});

const useWhiteVariantStyles = makeStyles(theme => ({
  ...baseStyles(theme),
  timeContainerYear: {
    backgroundImage: `url(${YearViewSvg})`
  },
  timeContainerQuarter: {
    backgroundImage: `url(${QuarterViewSvg})`,
    backgroundPositionX: 1,
    backgroundPositionY: 0
  },
  timeContainerMonth: {
    backgroundImage: `url(${MonthViewSvg})`
  },
  timeContainerWeek: {
    backgroundImage: `url(${WeekViewSvg})`
  },
  timeContainerDay: {
    backgroundImage: `url(${DayViewSvg})`
  }
}));

const usePurpleVariantStyles = makeStyles(theme => ({
  ...baseStyles(theme),
  timeContainerYear: {
    backgroundImage: `url(${DelaYearViewSvg})`
  },
  timeContainerQuarter: {
    backgroundImage: `url(${DelaQuarterViewSvg})`,
    backgroundPositionX: 1,
    backgroundPositionY: 0
  },
  timeContainerMonth: {
    backgroundImage: `url(${DelaMonthViewSvg})`
  },
  timeContainerWeek: {
    backgroundImage: `url(${DelaWeekViewSvg})`
  },
  timeContainerDay: {
    backgroundImage: `url(${DelaDayViewSvg})`
  }
}));

const useBlankVariantStyles = makeStyles(theme => ({
  ...baseStyles(theme),
  timeContainerYear: {
    backgroundImage: `url(${YearViewSvg})`
  },
  timeContainerQuarter: {
    backgroundImage: `url(${QuarterViewSvg})`,
    backgroundPositionX: 1,
    backgroundPositionY: 0
  },
  timeContainerMonth: {
    backgroundImage: `url(${MonthViewSvg})`
  },
  timeContainerWeek: {
    backgroundImage: `url(${BlankWeekViewSvg})`
  },
  timeContainerDay: {
    backgroundImage: `url(${BlankDayViewSvg})`
  }
}));

export const useVariantStyles = ({ variant, classesOverrides }) => {
  const whiteVariantClasses = useWhiteVariantStyles({
    classes: classesOverrides
  });
  const purpleVariantClasses = usePurpleVariantStyles({
    classes: classesOverrides
  });
  const blankVariantClasses = useBlankVariantStyles({
    classes: classesOverrides
  });

  if (variant === STYLED_CHART_RANGE_ITEM_VARIANT.PURPLE) {
    return purpleVariantClasses;
  }
  if (variant === STYLED_CHART_RANGE_ITEM_VARIANT.BLANK) {
    return blankVariantClasses;
  }

  return whiteVariantClasses;
};

export default useVariantStyles;
